var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60682 18C2.43398 19.4356 4.26834 19.9288 5.70393 19.1017C5.70491 19.1011 5.70585 19.1005 5.70684 19.1L6.15182 18.843C6.99182 19.5616 7.95735 20.119 8.9998 20.487V21C8.9998 22.6568 10.343 24 11.9998 24C13.6566 24 14.9998 22.6568 14.9998 21V20.487C16.0424 20.1184 17.008 19.5604 17.8478 18.841L18.2948 19.099C19.7307 19.9274 21.5664 19.4349 22.3948 17.999C23.2232 16.563 22.7308 14.7274 21.2948 13.899L20.8508 13.643C21.0507 12.5554 21.0507 11.4405 20.8508 10.353L21.2948 10.097C22.7307 9.26855 23.2232 7.43292 22.3948 5.99695C21.5664 4.56103 19.7308 4.06852 18.2948 4.89694L17.8498 5.15395C17.009 4.43616 16.0428 3.87984 14.9998 3.513V3C14.9998 1.34316 13.6566 0 11.9998 0C10.343 0 8.9998 1.34316 8.9998 3V3.513C7.95721 3.88158 6.99163 4.43958 6.15182 5.15902L5.70482 4.90003C4.26885 4.07156 2.43323 4.56408 1.6048 6C0.776383 7.43592 1.26885 9.27159 2.70482 10.1L3.14882 10.356C2.94895 11.4435 2.94895 12.5584 3.14882 13.646L2.70482 13.902C1.27284 14.7326 0.781961 16.5647 1.60682 18ZM11.9998 8.00002C14.2089 8.00002 15.9998 9.79088 15.9998 12C15.9998 14.2091 14.2089 16 11.9998 16C9.79068 16 7.99982 14.2091 7.99982 12C7.99982 9.79088 9.79068 8.00002 11.9998 8.00002Z",
    fill: "#7266BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPurple);
export default __webpack_public_path__ + "static/media/setting-purple.136f8d2b661714fccc68e3646f908cd4.svg";
export { ForwardRef as ReactComponent };